/**
 * Created by mark on 23/01/2018.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import HomeworkContentSelection from '../../../Homeowork-content-selection.js'
import CurriculumService from '../../../../services/curriculums-services.js';
import ModuleService     from '../../../../services/screens-service.js';
import ModulesStore      from '../../../../store/screen-store.js';
import ContentStore      from '../../../../store/content-store.js';
import ContentService from '../../../../services/content-service.js';

class CustomContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.props.data.sections = this.props.data.sections || [];
        this.curriculums = this.props.data.language.curriculums;
        this.history = [];
        this.state = {
            catalog:{items : ContentStore.getCatalog(this.catalogUID).vocab}
        }

    }

    getCurriculum(){
        let curriculums = Object.keys(this.curriculums).map(function(k) { return this.curriculums[k] }.bind(this));
        return curriculums[0]
    }

    componentWillMount(){
        this.fetchModules(null , true , <FormattedMessage id={ 'ui-000' } defaultMessage={ 'My Content' }/>)
    }

    componentDidMount() {
        ContentStore.on("ON_MY_CONTENT_UPDATE" , () => {

            this.catalogUID = null;
            var modules = ContentStore.modules.map(function(module){

                return {
                    catalog_uid:module.catalog_uid,
                    isLast :true,
                    title:module.title
                }
            });

            this.setState({modules : modules , catalog:{items : ContentStore.getCatalog(this.catalogUID).vocab}})
        });

        ContentStore.on('ON_VOCAB_FETCH'  , () => {
            this.setState({
                catalog:{items : ContentStore.getCatalog(this.catalogUID).vocab}
            });
        })
    }

    findHistoryIndex(screenUID){

        for(var idx = 0 ; idx < this.history.length; idx++ )
        {
            if(this.history[idx].screenID == screenUID ) return idx ;
        }

        return this.history.length;
    }

    fetchCatalog(catalogUID , crumbTranslation , screenID){
        this.history.push({name:crumbTranslation , screenID:screenID})
        this.catalogUID = catalogUID
        ContentService.fetchCatalog(catalogUID , this.props.data.language.ietf);
    }

    fetchModules(screenUID , isRoot , crumbTranslation){

        this.history = this.history.slice(0, this.findHistoryIndex(screenUID));
        this.history.push({name:crumbTranslation , screenID:screenUID})

        ContentService.fetchModulesForLanguage(this.props.data.language.ietf);
    }

    onSelected(sections){

        let crumb = this.history[this.history.length - 2];
        this.props.data.sections = sections;
        this.fetchModules(crumb.screenID , false , crumb.name);
    }

    render(){
       return <HomeworkContentSelection totalWords={this.totalWords} fetchCatalog={this.fetchCatalog.bind(this)} catalogUID={this.catalogUID} modules={this.state.modules} history={this.history} fetchModules={this.fetchModules.bind(this)} catalog={this.state.catalog} onSelected={this.onSelected.bind(this)} language={this.props.data.language} sections={this.props.data.sections}/>
    }

}

export default {
    name: <FormattedMessage id={ 'ui-000' } defaultMessage={ 'My Content' }/>,
    title:null,
    removePadding:true,
    navigationTop:true,
    onSubmit: function (done){

        done();

    },
    component: CustomContent
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/vocabulary-builder/custom-content.js